"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = FinProOrAgencyDropdown;
var _react = _interopRequireDefault(require("react"));
var _reactBootstrap = require("react-bootstrap");
var _reactBlueprintLibrary = require("react-blueprint-library");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function FinProOrAgencyDropdown(_ref) {
  var {
    searchState,
    setSearchState,
    finProOrAgencySelectionArray,
    isDesktop,
    sourcePage,
    setIsLoading,
    handleFinalSearch
  } = _ref;
  var searchTextPrefix = searchState.finProOrAgencySelection === 'Financial Professional' ? "I'm looking for a" : "I'm looking for an";
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Label, {
    className: "copy-lg ".concat(isDesktop ? 'add-margin-right' : 'add-margin-bottom'),
    htmlFor: 'finpro-or-agent-dropdown'
  }, /*#__PURE__*/_react.default.createElement("strong", null, "".concat(searchTextPrefix))), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Group, {
    className: "form-group"
  }, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.DropdownSelect, {
    key: 'finProOrAgencySelection',
    data: finProOrAgencySelectionArray,
    onSelect: value => {
      // Clear API data when dropdown selection is changed
      // To ensure that Agency/Agent results does not try to use previous FinPro API call results
      if (sourcePage !== 'home') {
        setIsLoading(true);
      }
      setSearchState(prevState => {
        return _objectSpread(_objectSpread({}, prevState), {}, {
          finProOrAgencySelection: value,
          distanceMiles: 5,
          distanceFilterSelectionIndex: 1,
          languageSelection: [],
          specialtySelection: []
        });
      });
      // If not on home page, dropdown selection should trigger API call
      if (sourcePage !== 'home') {
        setSearchState(prevState => {
          return _objectSpread(_objectSpread({}, prevState), {}, {
            distanceMiles: 5,
            languageSelection: [],
            specialtySelection: [],
            lastSearchedWasByName: searchState.searchByName
          });
        });
        handleFinalSearch();
      }
    },
    defaultSearchValue: searchState.finProOrAgencySelection,
    defaultLabel: searchState.finProOrAgencySelection,
    toggleId: 'finpro-or-agent-dropdown',
    toggleName: 'finpro-or-agent-dropdown'
  })));
}